
import axios from 'axios'
import Vue from 'vue'
import CurrencySelect from '@/domains/global/components/CurrencySelect.vue'
import AccountingDisplayCard from './AccountingDisplayCard.vue'

type AccountLinkResponse = {
  redirect: boolean;
  url: string;
}

export default Vue.extend({
  components: { AccountingDisplayCard, CurrencySelect },
  props: {
    accounting: { type: Object as () => any, default: () => null }
  },
  computed: {
    hasStripeAccount(): boolean {
      return !!this.accounting?.stripe
    },
    checks(): { setup: boolean, connected: boolean } {
      return {
        setup: !!this.accounting?.stripe?.details_submitted,
        connected: !!this.accounting?.stripe?.charges_enabled
      }
    }
  },
  methods: {
    async createAccount() {
      try {
        const response = await axios.post<AccountLinkResponse>('/profile/stripe')
        if (response.data?.redirect) {
          window.location = response.data.url as (string & Location)
        }
      } catch (error) {
        // @ts-ignore:next-line
        this.handleError(error)
      }
    },
    async connectAccount() {
      try {
        const response = await axios.get<AccountLinkResponse>('/profile/stripe/connect')
        if (response.data.redirect) {
          window.location = response.data.url as (string & Location)
        }
      } catch (error) {
        // @ts-ignore:next-line
        this.handleError(error)
      }
    },
    async updateCurrency(code: string) {
      try {
          await axios.post(`/profile/accounting/currency`, { currency: code })
          this.accounting.currency = code
        } catch (error) {
          // @ts-ignore:next-line
          this.handleError(error)
        }
    }
  }
})
